import React, { useContext, useState } from 'react';
import { ProductListViewContext } from '../ProductListView';
import ContentData from '../../../../constants/contentFile.json';
import SearchData from '../../../../components/SearchComponent/SearchData';
import { Container, Dropdown } from 'react-bootstrap';
import Loader from '../../../../components/Loader/Loader';
import './productList.css';
import PluseIcon from '../../../../assets/images/pluse.svg';
import DataTable from '../../../../components/TableComponent/DataTable';
import TabsComponent from '../../../../components/TabComponent/TabsComponent';
import FilterIcon from '../../../../assets/images/icons/filter-icon.svg';
import ErrorPopup from '../../../../components/PopupAlertError/PopupAlertError';
import DropUpIcon from '../../../../assets/images/icons/dropup-icon.svg';
import DropDownIcon from '../../../../assets/images/icons/dropdown-icon.svg';
import ThemeButton from '../../../../components/ThemeButton/ThemeButton';

const ProductList = () => {
  const {
    onChangeSearch,
    searchData,
    spinnerStatus,
    onPageChange,
    pageCount,
    totalPage,
    addProduct,
    permissionAccess,
    productList,
    tabValue,
    handleTabChange,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    productToLogin,
    buttonText,
    inverterListAPI,
    statusValue,
    selectedStatusId,
    setSelectedStatusId,
    showDropdown,
    handleSelect,
    handleToggle,
    setStatus,
    onClickFilterButton,
  } = useContext(ProductListViewContext);
  const [isStatusExpanded, setIsStatusExpanded] = useState(false);
  const statuses = [
    { id: 'A', name: 'Active' },
    { id: 'I', name: 'Inactive' },
  ];
  const header = [
    { title: 'MODEL', prop: 'model' },
    { title: 'POWER', prop: 'power' },
    { title: 'TYPE', prop: 'type' },
    { title: 'SITE ORIGIN ', prop: 'siteOrigin' },
    { title: 'STATUS', prop: 'status' },
    { title: ' ', prop: 'action' },
  ];

  const batteryHeader = [
    { title: 'MODEL', prop: 'model' },
    { title: 'CAPACITY', prop: 'capacity' },
    { title: 'PRODUCT LINK', prop: 'productLink' },
    { title: 'SITE ORIGIN ', prop: 'siteOrigin' },
    { title: 'STATUS', prop: 'status' },
    { title: ' ', prop: 'action' },
  ];

  const tabs = [
    {
      label: 'Inverter',
      value: '1',
      content: (
        <>
          <div className="searchAddSection adminRole">
            <div className="searchSection">
              <SearchData
                placeholder={ContentData.productPage.searchData}
                value={searchData}
                onChange={onChangeSearch}
                type="text"
              />
            </div>
            <div className="plusRefreshDtat">
              <Dropdown
                autoClose="outside"
                show={showDropdown}
                onToggle={handleToggle}
              >
                <Dropdown.Toggle
                  variant="link"
                  id="dropdown-basic"
                  className="custom-dropdown-toggle"
                >
                  <div className="adminFilterIcon">
                    <img src={FilterIcon} alt="filter" />
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="admin-dropdown-menu "
                  style={{
                    backgroundColor: '#F7F8FA',
                    width: '258px',
                    marginTop: '34px',
                  }}
                >
                  <Dropdown.Item className="dropdown-filter-clear">
                    <span className="filter-text">
                      {ContentData.productPage.filter}
                    </span>
                    <span
                      className="clear-all"
                      onClick={() => {
                        handleSelect();
                        setStatus('');
                        setSelectedStatusId('');
                      }}
                    >
                      {ContentData.productPage.clearAll}
                    </span>
                  </Dropdown.Item>

                  <Dropdown.Item
                    className={`firstItem dropdownItem ${
                      isStatusExpanded ? 'expanded' : ''
                    }`}
                    onClick={e => {
                      e.stopPropagation();
                      setIsStatusExpanded(!isStatusExpanded);
                    }}
                    style={{
                      borderBottom: '0',
                    }}
                  >
                    Status
                    <img
                      src={isStatusExpanded ? DropUpIcon : DropDownIcon}
                      alt="toggle"
                    />
                  </Dropdown.Item>

                  {/* Status items */}
                  {isStatusExpanded &&
                    statuses.map(status => (
                      <Dropdown.Item
                        className={`dropdownItem status-item ${
                          selectedStatusId === status.id ? 'selected' : ''
                        }`}
                        key={status.id}
                        onClick={e => {
                          e.stopPropagation();
                          const newStatusId =
                            selectedStatusId === status.id ? '' : status.id;
                          setSelectedStatusId(newStatusId);
                        }}
                        style={{
                          paddingLeft: '20px',
                          height: '48px',
                        }}
                      >
                        {status.name}
                      </Dropdown.Item>
                    ))}

                  {/* Apply Button */}
                  <Dropdown.Item className="dropdownItem status-item tenantThemeBtn">
                    <ThemeButton
                      value={'Apply'}
                      className={''}
                      onClick={() => {
                        onClickFilterButton(selectedStatusId);
                        handleToggle(false); // Close the dropdown
                      }}
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div
                className={`addProduct  addDataProduct ${
                  permissionAccess?.add ? '' : 'disabledMainButton'
                } `}
                onClick={() => addProduct()}
              >
                <img src={PluseIcon} alt="add" />
                <span>{ContentData.productPage.addProduct}</span>
              </div>
            </div>
          </div>
          <div className="basicContainer roleListTable">
            <DataTable
              tableData={productList}
              header={header}
              onPageChange={e => onPageChange(e)}
              isPagination={true}
              currentPage={pageCount}
              pageCount={totalPage}
            />
          </div>
        </>
      ),
    },
    {
      label: 'Battery',
      value: '2',
      content: (
        <>
          <div className="searchAddSection adminRole">
            <div className="searchSection">
              <SearchData
                placeholder={ContentData.productPage.searchDataBattery}
                value={searchData}
                onChange={onChangeSearch}
                type="text"
              />
            </div>
            <div className="plusRefreshDtat">
              <Dropdown
                autoClose="outside"
                show={showDropdown}
                onToggle={handleToggle}
              >
                <Dropdown.Toggle
                  variant="link"
                  id="dropdown-basic"
                  className="custom-dropdown-toggle"
                >
                  <div className="adminFilterIcon">
                    <img src={FilterIcon} alt="filter" />
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="admin-dropdown-menu "
                  style={{
                    backgroundColor: '#F7F8FA',
                    width: '258px',
                    marginTop: '34px',
                  }}
                >
                  <Dropdown.Item className="dropdown-filter-clear">
                    <span className="filter-text">
                      {ContentData.productPage.filter}
                    </span>
                    <span
                      className="clear-all"
                      onClick={() => {
                        handleSelect();
                        setStatus('');
                        setSelectedStatusId('');
                      }}
                    >
                      {ContentData.productPage.clearAll}
                    </span>
                  </Dropdown.Item>

                  <Dropdown.Item
                    className={`firstItem dropdownItem ${
                      isStatusExpanded ? 'expanded' : ''
                    }`}
                    onClick={e => {
                      e.stopPropagation();
                      setIsStatusExpanded(!isStatusExpanded);
                    }}
                    style={{
                      borderBottom: '0',
                    }}
                  >
                    Status
                    <img
                      src={isStatusExpanded ? DropUpIcon : DropDownIcon}
                      alt="toggle"
                    />
                  </Dropdown.Item>

                  {/* Status items */}
                  {isStatusExpanded &&
                    statuses.map(status => (
                      <Dropdown.Item
                        className={`dropdownItem status-item ${
                          selectedStatusId === status.id ? 'selected' : ''
                        }`}
                        key={status.id}
                        onClick={e => {
                          e.stopPropagation();
                          const newStatusId =
                            selectedStatusId === status.id ? '' : status.id;
                          setSelectedStatusId(newStatusId);
                        }}
                        style={{
                          paddingLeft: '20px',
                          height: '48px',
                        }}
                      >
                        {status.name}
                      </Dropdown.Item>
                    ))}

                  {/* Apply Button */}
                  <Dropdown.Item className="dropdownItem status-item tenantThemeBtn">
                    <ThemeButton
                      value={'Apply'}
                      className={''}
                      onClick={() => {
                        onClickFilterButton(selectedStatusId);
                      }}
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div
                className={`addProduct  addDataProduct ${
                  permissionAccess?.add ? '' : 'disabledMainButton'
                } `}
                onClick={() => addProduct()}
              >
                <img src={PluseIcon} alt="add" />
                <span>{ContentData.productPage.addProduct}</span>
              </div>
            </div>
          </div>
          <div className="basicContainer roleListTable">
            <DataTable
              tableData={productList}
              header={batteryHeader}
              onPageChange={e => onPageChange(e)}
              isPagination={true}
              currentPage={pageCount}
              pageCount={totalPage}
            />
          </div>
        </>
      ),
    },
    {
      label: 'Combo',
      value: '3',
      content: (
        <>
          <div className="searchAddSection adminRole">
            <div className="searchSection">
              <SearchData
                placeholder={ContentData.productPage.searchData}
                value={searchData}
                onChange={onChangeSearch}
                type="text"
              />
            </div>
            <div className="plusRefreshDtat">
              <Dropdown
                autoClose="outside"
                show={showDropdown}
                onToggle={handleToggle}
              >
                <Dropdown.Toggle
                  variant="link"
                  id="dropdown-basic"
                  className="custom-dropdown-toggle"
                >
                  <div className="adminFilterIcon">
                    <img src={FilterIcon} alt="filter" />
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="admin-dropdown-menu "
                  style={{
                    backgroundColor: '#F7F8FA',
                    width: '258px',
                    marginTop: '34px',
                  }}
                >
                  <Dropdown.Item className="dropdown-filter-clear">
                    <span className="filter-text">
                      {ContentData.productPage.filter}
                    </span>
                    <span
                      className="clear-all"
                      onClick={() => {
                        handleSelect();
                        setStatus('');
                        setSelectedStatusId('');
                      }}
                    >
                      {ContentData.productPage.clearAll}
                    </span>
                  </Dropdown.Item>

                  <Dropdown.Item
                    className={`firstItem dropdownItem ${
                      isStatusExpanded ? 'expanded' : ''
                    }`}
                    onClick={e => {
                      e.stopPropagation();
                      setIsStatusExpanded(!isStatusExpanded);
                    }}
                    style={{
                      borderBottom: '0',
                    }}
                  >
                    Status
                    <img
                      src={isStatusExpanded ? DropUpIcon : DropDownIcon}
                      alt="toggle"
                    />
                  </Dropdown.Item>

                  {/* Status items */}
                  {isStatusExpanded &&
                    statuses.map(status => (
                      <Dropdown.Item
                        className={`dropdownItem status-item ${
                          selectedStatusId === status.id ? 'selected' : ''
                        }`}
                        key={status.id}
                        onClick={e => {
                          e.stopPropagation();
                          const newStatusId =
                            selectedStatusId === status.id ? '' : status.id;
                          setSelectedStatusId(newStatusId);
                        }}
                        style={{
                          paddingLeft: '20px',
                          height: '48px',
                        }}
                      >
                        {status.name}
                      </Dropdown.Item>
                    ))}

                  {/* Apply Button */}
                  <Dropdown.Item className="dropdownItem status-item tenantThemeBtn">
                    <ThemeButton
                      value={'Apply'}
                      className={''}
                      onClick={() => {
                        onClickFilterButton(selectedStatusId);
                        handleToggle(false); // Close the dropdown
                      }}
                    />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div
                className={`addProduct  addDataProduct ${
                  permissionAccess?.add ? '' : 'disabledMainButton'
                } `}
                onClick={() => addProduct()}
              >
                <img src={PluseIcon} alt="add" />
                <span>{ContentData.productPage.addProduct}</span>
              </div>
            </div>
          </div>
          <div className="basicContainer roleListTable">
            <DataTable
              tableData={productList}
              header={header}
              onPageChange={e => onPageChange(e)}
              isPagination={true}
              currentPage={pageCount}
              pageCount={totalPage}
            />
          </div>
        </>
      ),
    },
  ];

  return (
    <div className="pageBg">
      <div className="breadCrums boldBreadCrums">
        <span>{ContentData.productPage.pageTitle}</span>
      </div>
      <Container>
        {spinnerStatus && <Loader />}
        <div className="pageTittles-product-list">
          {ContentData.productPage.pageTitle}
        </div>
        <TabsComponent
          tabs={tabs}
          onChange={handleTabChange}
          value={tabValue}
        />
      </Container>
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            productToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            inverterListAPI(pageCount, searchData);
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />
    </div>
  );
};

export default ProductList;
